/**
 * Query-key prefixes that are safe + useful to persist for offline navigation.
 * Kept to small, slow-changing metadata so the persisted blob fits localStorage.
 * Large/volatile data (vector features, byproducts, image POIs) is intentionally
 * excluded — the offline snapshot store holds those instead. Image POIs reach
 * 10+ MB for a mobile-mapping run (9198 Ladybug images), past localStorage's
 * quota, and `loadImagesByLayerOfflineAware` falls back to the snapshot.
 */
const PERSIST_PREFIXES = new Set([
  'me',
  'organizations',
  'projects',
  'projectFolders',
  'project',
  'layers',
  'layersNested',
]);

export function shouldPersistQueryKey(queryKey: readonly unknown[]): boolean {
  const head = queryKey[0];
  return typeof head === 'string' && PERSIST_PREFIXES.has(head);
}
